(function () {
	angular.module('components.accordionColumns', [])
		.component('accordionColumn', {
			require: {
				accordionColumns: '^accordionColumns'
			},
			bindings: {
				title: '@',
				links: '<'
			},
			template: '<h3>{{$ctrl.title}}</h3><ul class="no-bullet" ng-class="{active: $ctrl.active === true}"><li ng-repeat="link in $ctrl.links"><a ng-class="{active: link.active, loading: link.loading}" ng-click="$ctrl.activate(link)">{{link.name}}</a></li></ul>',
			controller: accordionColumnController
		});

	accordionColumnController.$inject = ['$element']
	function accordionColumnController($element) {
		var ctrl = this;
		ctrl.$onInit = function () {
		    $element.addClass('grid-content');
			ctrl.$element = $element;
			ctrl.verticalTitle = ctrl.title;
			var split = ctrl.title.split(' ');
			if (split.length > 1) {
				ctrl.verticalTitle = '<span>' + split.join('</span><span>') + '</span>';
			}
			ctrl.accordionColumns.registerColumn(ctrl);
		}

		ctrl.clear = function () {
		    if (ctrl.currentLink) {
		        ctrl.currentLink.active = false;
		        ctrl.currentLink.loading = false;
		    }
		}

		ctrl.activate = function (link) {
		    ctrl.accordionColumns.clear();
		    ctrl.clear();
			link.active = true;
			link.loading = true;
			ctrl.currentLink = link;
			ctrl.accordionColumns.activateColumn(ctrl);
		}
	}
})();